import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import StatisticsByReactivationTable from './StatisticsByReactivationTable.js';
import {
    mainSelector,
    getHeaderName,
    getMetrics,
    getKeysMetric,
    getRowsCount
} from './StatisticsByReactivationTable.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    data: mainSelector,
    headerName: getHeaderName,
    metrics: getMetrics,
    keysMetric: getKeysMetric,
    rowsCount: getRowsCount
});

const StatisticsByReactivationTableComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.statistics.data.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsByReactivationTable);

export default StatisticsByReactivationTableComponent;
